<template>
    <div v-show="isShow">
        <div class="bg_top">
            <div class="user_info_div">
                <img :src="imgUrl" class="user_adv">
                <div class="user_name">{{weChatName}}</div>
            </div>
            <div class="device_address" @click="switchDevice">
                <img src="../assets/2.png" class="device_img">
                <div class="device_text">{{address}}</div>
            </div>
            <div class="recharge_div" v-if="bound">
                <div class="recharge_text">账户余额</div>
                <div class="recharge_content">
                    <div><span>{{degress}}</span><span>元</span></div>
                    <!-- <div class="refresh_btn" @click="refreshFun">刷新</div> -->
                </div>
                <div class="recharge_block" @click="onRecharge"><span>充值</span></div>
            </div>
        </div>
        <div class="info_list" v-if="bound">
            <div class="info_item" v-for="(item,index) in list" :key="index" data-item="ffd" @click="threeList(index)">
                <img :src="item.img" class="info_img">
                <div class="info_text">{{item.text}}</div>
            </div>
        </div>
        <div class="device_info_text" v-if="!bound">暂无设备信息</div>
        <div class="myDeviceDiv" v-show="myDeviceDiv">
            <div v-for="(item,index) in myDeviceList" :key="index" class="myDeviceItem" :index="index" @click="switchDeviceFun($event)">
                <div 
                    class="deviceSwitchBtn" 
                    :class="[index == selectDeviceIndex ? 'action' : '']"
                >{{index == selectDeviceIndex ? '当前' : '切换'}}</div>
                <div class="deviceSwitchText">{{item.address}}-{{item.shopName}}</div>
            </div>
        </div>
    </div>
</template>

<script>
import autho from '../autho/autho.js'
import Vue from 'vue';
import { Toast } from 'vant';

Vue.use(Toast);
var that;
export default {
    data(){
        return {
            list:[
                {
                    img:require('../assets/3.png'),
                    text:'用量详情'
                },
                {
                    img:require('../assets/4.png'),
                    text:'账单记录'
                },
                {
                    img:require('../assets/5.png'),
                    text:'申请退款'
                }
            ],
            imgUrl:'',
            weChatName:'游客',
            address:'我的设备',
            bound:true,
            myDeviceDiv:false,
            myDeviceList:[],
            selectDeviceIndex:0,
            degress:0,
            accountCode:null,
            isShow:false,
            store_name:'',
            userInfo:'',
			snCode:''
        }
    },
    beforeCreate(){
        document.querySelector('body').style.background = '#f6f6f6'
    },
    beforeMount(){
        
    },
    activated(){
        that = this;
        that.requestFun()
    },
    methods:{
        // 获取用户信息
        async requestFun(){
            const res = await autho.request('token','post','/gzhWxApiController/userinfo',{})

            autho.resetDataFun(res,function(){
                let _data = res.data.data;
                that.userInfo = _data;
                if(_data.headImg){
                    that.imgUrl = _data.headImg;
                }
                if(_data.nickName){
                    that.weChatName = _data.nickName;
                }
                if(_data.phone){
                    that.getDeviceList()
                }else{
                    that.$router.push({path:'/empower'})
                }
            })
        },
        // 获取设备列表
        async getDeviceList(){
            const res = await autho.request('token','post','/gzhWxApiController/getDeviceList',{})

            autho.resetDataFun(res,function(){
                let _data = res.data.data;
                if(_data.length > 0){
                    that.store_name = `${_data[0].address}-${_data[0].shopName}`;
                    that.bound = true;
                    that.address = '我的设备 ' + that.store_name;
                    that.degress = _data[0].money ? _data[0].money : 0;
                    that.myDeviceList = _data;
                    that.accountCode = _data[0].accountCode;
					that.snCode = _data[0].snCode;
					that.selectDeviceIndex = 0;
                }else{
                    that.bound = false;
                }
                that.isShow = true;
				console.log(that.address)
            })
        },
        // 充值跳转
        onRecharge(){
            // if(that.userInfo.openid == 'oQkUt5nAIQdveQEEETize0uQ08NM' || that.userInfo.openid == 'oQkUt5nA6R46chbtt1bdXubzHJTk' || that.userInfo.openid == 'oQkUt5lBPrC-HfyyAe7EGlP1U-Co' || that.userInfo.openid == 'oQkUt5pyAZj440zC6mJ6p06f_RgA'){
            //     that.$router.push({path:'/recharge',query:{accountCode:that.accountCode}})
            // }else{
            //     Toast({message:'系统维护中',forbidClick:true});
            // }
            console.log(that.store_name)
            that.$router.push({path:'/recharge',query:{accountCode:that.accountCode,snCode:that.snCode,storeName:that.store_name}})
        },
        // 用电详情、账单记录、公告通知跳转
        async threeList(val){
            if(val == 0){
                that.$router.push({path:'/dosage_details',query:{accountCode:that.accountCode}})
            }else if(val == 1){
                that.$router.push({path:'/billing_record',query:{accountCode:that.accountCode}})
            }else if(val == 2){
                // that.$router.push('/notice')
                
                const res = await autho.request('token','post','/gzhWxApiController/selectRefund',{accountCode:that.accountCode})

                autho.resetDataFun(res,function(){
                    let _data = res.data.data;
                    if(_data == 'null' || _data == null || _data == ''){
                        that.$router.push({path:'/refund',query:{accountCode:that.accountCode,address:that.store_name}})
                    }else{
                        Toast({message:'你已申请退款',forbidClick:true});
                    }
                })
            }
        },
        // 是否显示切换设备列表块
        switchDevice(){
            if(that.myDeviceList.length > 0){
                that.myDeviceDiv = true
            }
        },
        // 选择设备
        switchDeviceFun(e){
            let _index = e.currentTarget.getAttribute('index');
				that.store_name = `${that.myDeviceList[_index].address}-${that.myDeviceList[_index].shopName}`;
                that.myDeviceDiv = false;
                that.selectDeviceIndex = _index;
                that.address = '我的设备 ' + that.store_name;
                that.degress = that.myDeviceList[_index].money;
                that.accountCode = that.myDeviceList[_index].accountCode;
				that.snCode = that.myDeviceList[_index].snCode;
			console.log(that.address)
        },
        // 刷新
        // async refreshFun(){
        //     const res = await autho.request('token','post','/gzhWxApiController/updateBalance',{deviceId:1})

        //     autho.resetDataFun(res,function(){
                
        //     })
        // }
    }
}
</script>


<style scoped>
/* 
scoped 仅仅应用到父元素及子元素
lang 语言的定义
*/
html,body {
    background: #f6f6f6;
}
.bg_top {
    height: 2.25rem;
    display: flex;
    align-content: center;
    flex-wrap: wrap;
    background-image: url(../assets/1.jpg);
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center center;
    padding: 0.15rem;
    position: relative;
}
.user_info_div {
    display: flex;
    align-items: center;
    width: 100%;
}
.user_adv {
    width: 0.5rem;
    height: 0.5rem;
    border-radius: 50%;
    margin-right: 0.1rem;
}
.user_name {
    font-size: 0.2rem;
    color: #fff;
}
.device_address {
    display: flex;
    align-items: center;
    margin-top: 0.1rem;
}
.device_img {
    width: 0.3rem;
    height: 0.3rem;
    margin-right: 0.06rem;
}
.device_text {
	font-size: .16rem;
    color: #fff;
}
.recharge_div {
    width: 3.45rem;
    height: 1.3rem;
    background: #fff;
    position: absolute;
    left: 50%;
    bottom: -0.9rem;
    margin-left: -1.725rem;
    box-shadow: -0rem 0.02rem 0.02rem 0px #ddd;
    border-radius: 0.1rem;
    overflow: hidden;
    transform: rotate(0deg);
}
.recharge_text {
    margin: 0.2rem 0 0 0.2rem;
    font-size: 0.14rem;
    color: #607da4;
}
.recharge_content {
    margin: 0.15rem 0 0 0.2rem;
    display: flex;
    align-items: baseline;
    width: 80%;
}
.refresh_btn {
    border: 1px solid #ccc;
    border-radius: 0.05rem;
    padding: 0.02rem 0.1rem;
    font-size: 0.12rem;
    margin-left: 0.2rem;
}
.recharge_content span:first-child {
    color: #4c97fc;
    font-size: 0.5rem;
}
.recharge_content span:last-child {
    color: #607da4;
    font-size: 0.14rem;
}
.recharge_block {
    position: absolute;
    right: -0.5rem;
    top: -5%;
    background: #42638e;
    width: 1rem;
    height: 110%;
    border-radius: 50%;
    cursor: pointer;
}
.recharge_block span {
    writing-mode:vertical-lr;
    position: absolute;
    left: 0.16rem;
    top: 50%;
    color: #fff;
    font-size: 0.17rem;
    margin-top: -0.17rem;
}
/*  */
.info_list {
    height: 1.3rem;
    width: 3.45rem;
    border-radius: 0.1rem;
    background: #fff;
    display: flex;
    margin: 1.1rem auto 0;
    justify-content: space-around;
    align-items: center;
}
.info_item {
    text-align: center;
    cursor: pointer;
}
.info_img {
    width: 0.5rem;
    height: 0.5rem;
    border-radius: 50%;
}
.info_text {
    font-size: 0.14rem;
}

/*  */
.device_info_text {
    text-align: center;
    margin-top: 1rem;
    font-size: 0.16rem;
    color: #666;
}

/* 我的设备切换 */
.myDeviceDiv {
    position: fixed;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    background: #f6f6f6;
    padding-top: 0.1rem;
    box-sizing: border-box;
	overflow-y: auto;
}
.myDeviceItem {
    height: 0.4rem;
    background: #fff;
    display: flex;
    align-items: center;
    padding: 0 0.1rem;
}
.deviceSwitchBtn {
	background: #3077d6;
    height: 0.25rem;
    width: 0.8rem;
    border-radius: 0.05rem;
    text-align: center;
    line-height: 0.25rem;
    font-size: 0.16rem;
    color: #fff;
    margin-right: 0.05rem;
}
.deviceSwitchBtn.action {
    background: #db5e37;
}
.deviceSwitchText {
    font-size: 0.16rem;
    flex: 1;
}
</style>